/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { preventBrowserTooltipStyle } from '../themes/Common.css';

// Pointer Enter handler for elements that need to prevent default browser tooltips
const _pointerEnterHandler = (event: PointerEvent) => {
  const targetElement = event.target as HTMLElement;
  targetElement.classList.add(preventBrowserTooltipStyle);
};

// Pointer Leave handler for elements that need to prevent default browser tooltips
const _pointerLeaveHandler = (event: PointerEvent) => {
  const targetElement = event.target as HTMLElement;
  targetElement.classList.remove(preventBrowserTooltipStyle);
};

/*
 * Props that can be spread on elements that need to prevent default browser tooltips
 */
export const preventBrowserTooltipProps = {
  onPointerEnter: _pointerEnterHandler,
  onPointerLeave: _pointerLeaveHandler
};
